export default __webpack_public_path__ + "static/media/working-together.4ffc8645.png";